<template>
  <div class="field" :class="style">
    <label :for="inputId"
      >{{ label }}
      <span v-if="required" class="field-required">*</span>
    </label>
    <div class="field-container">
      <input
        :id="inputId"
        v-model="model"
        class="field-input"
        type="text"
        :class="{ '--min': isHasPrefix }"
        :readonly="readonly"
        :placeholder="placeholder"
        @focus="changeFocused(true)"
        @blur="changeFocused(false)"
      />
      <div v-if="isHasPrefix" class="field-input__prefix">
        <slot name="prefix" />
      </div>
    </div>
    <div v-if="errorMessage" class="field-error">
      <img src="../assets/error.svg" alt="" />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: "",
      },
      value: {
        type: [String, Number],
        default: "",
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: "",
      },
      required: {
        type: Boolean,
        default: false,
      },
      errorMessage: {
        type: String,
        default: "",
      },
    },

    data() {
      return {
        isFocused: false,
      };
    },

    computed: {
      model: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },

      isHasPrefix() {
        return !!(this.$slots || {}).prefix;
      },

      style() {
        return {
          "--is-focused": this.isFocused,
          "--is-error": !!this.errorMessage,
        };
      },

      inputId() {
        return `field-${this._uid}`;
      },
    },

    methods: {
      changeFocused(val) {
        this.isFocused = val;
      },
    },
  };
</script>

<style lang="scss">
  .field {
    width: 100%;
    margin-bottom: 24px;
    position: relative;

    &.--is-error {
      input {
        border-color: #e82a41;
      }
    }

    &-container {
      position: relative;
    }

    &-required {
      color: #e82a41;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }

    &-error {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #e82a41;
      position: absolute;
      display: flex;
      width: 100%;
      bottom: -24px;
      left: 0;
      justify-content: left;
      align-items: center;

      img {
        height: 16px;
        margin-right: 8px;
      }
    }

    label {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.5px;
      color: #7f8fa4;
      margin-bottom: 6px;
      float: left;
    }

    &-input {
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e1e8ee;
      border-radius: 6px;
      color: #334150;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.5px;
      outline: unset;
      transition: border-color 0.3s;

      &.--min {
        padding-right: 52px;
      }

      &__prefix {
        position: absolute;
        bottom: 10px;
        right: 20px;
      }

      &::placeholder {
        color: #cdd5db;
      }

      &:hover {
        border-color: #cdd5db;
      }

      &:focus {
        border-color: #0020ff;
      }
    }
  }

  html[data-color-scheme='dark'] {
    .field {
      label {
        color: #ffffff;
      }

      &-input {
        background: #323232;
        border-color: #4a4a4a;
        color: #ffffff;

        &::placeholder {
          color: #8a8a8a;
        }

        &:hover,
        &:focus {
          border-color: #6b6b6b;
        }
      }
    }
  }
</style>
